import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config/api-urls';
import { getApiClient } from './api-client';

export const kivpApi = () => {
  const baseURL = `${getEnvironmentApiUrls().kiVp}`;

  const api = getApiClient(baseURL);

  const getUrlFromModule = async (moduleType: string) =>
    api.get<string>(`/one-note?moduleType=${moduleType}`);

  return {
    getUrlFromModule,
  };
};
